// Generated by genversion.
export const version = '1.2.4'
export const versionHash = '488CF5A';
